export enum CrudStatus {
    NoAction,
    Create,
    Update,
    Delete,
    Archive
}



// WEBPACK FOOTER //
// ./src/common/enums/crud-status.enum.ts